'use strict';

var novicell = novicell || {};

novicell.aspnetValidation = novicell.aspnetValidation || new function () {
    this.init = function() {
  
        let v = new aspnetValidation.ValidationService();
        v.bootstrap();
    };
};
